module.exports = __webpack_public_path__ + "img/Haru1.5952cba0.png";